import { AdminRoles, AdminStatus, IGetAdminsListDTO } from '@/models/admins.model';
import { TAdminFiltersValues, AdminFiltersFields } from '../helpers/types';

class GetAdminsListDTO implements IGetAdminsListDTO {
  full_name?: string;
  email?: string;
  phone_number?: string;
  limit?: number;
  status?: AdminStatus;
  role?: AdminRoles;
  cursor?: string;

  constructor(values: TAdminFiltersValues) {
    this.status = values[AdminFiltersFields.STATUS];
    this.role = values[AdminFiltersFields.ROLE];
    this.full_name = values[AdminFiltersFields.NAME];
    this.phone_number = values[AdminFiltersFields.PHONE_NUMBER];
    this.email = values[AdminFiltersFields.EMAIL];
    this.limit = values?.limit ?? 30;
    this.cursor = values?.cursor;
  }
}

export default GetAdminsListDTO;
